<div class="header-banrep-leaderboard">
    <ul class="header-banrep-leaderboard-menu">
        <li>
            <a href="https://www.banrep.gov.co/es">Portal corporativo</a>
        </li>
        <li>
            <a href="https://investiga.banrep.gov.co/es">Portal de investigaciones económicas</a>
        </li>
        <li>
            <a href="https://www.banrep.gov.co/es/transparencia/atencion-ciudadania">Atención a la ciudadanía</a>
        </li>
    </ul>
</div>
<header>

</header>
<div class="header-banrep">
    <div class="header-banrep-branding">
        <div class="header-banrep-logo">
            <img src="/estadisticas-economicas/assets/img/cab-brc-estadisticas.jpg" class="img-logo-mona" [routerLink]="['/']">
        </div>
    </div>    
    <app-mega-menu></app-mega-menu>
</div>